import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/settings/user/$id/edit')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/_app/settings/user/$id/edit"!</div>
}
